import * as React from 'react';
import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';
import * as Device from 'react-device-detect';

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function SlidersWrapper(props: Readonly<WrapperProps>) {
  const { children, sx, ...rest } = props;

  return (
    <Stack
      spacing={Device.isMobileOnly ? 4 : 8}
      mt={Device.isMobileOnly ? 2 : '-15dvh'}
      sx={{ position: 'relative', ...sx }}
      {...rest}
    >
      {children}
    </Stack>
  );
}

export function SliderWrapper(props: Readonly<WrapperProps>) {
  const { children, sx: incomingSx, ...rest } = props;

  const sx = Device.isDesktop
    ? {
        overflowX: 'scroll',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '& > :nth-of-type(1)': {
          '&:hover .container': {
            transformOrigin: 'center left',
          },
        },
        '& > :nth-last-of-type(1)': {
          '&:hover .container': {
            transformOrigin: 'center right',
          },
        },
        ...incomingSx,
      }
    : {
        overflowX: 'scroll',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        msOverflowStyle: 'none',
        ...incomingSx,
      };

  return (
    <Stack spacing={1} direction="row" px={{ xs: 2, sm: 3, md: 10 }} sx={sx} {...rest}>
      {children}
    </Stack>
  );
}

export function SlideWrapper(props: Readonly<WrapperProps>) {
  const { children, sx: incomingSx, ...rest } = props;

  return (
    <Stack
      spacing={2}
      direction="row"
      px={{ xs: 2, sm: 3, md: 10 }}
      py={20}
      sx={{
        overflowX: 'scroll',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '& > :nth-of-type(1)': {
          '&:hover .container': {
            transformOrigin: 'center left',
          },
        },
        '& > :nth-last-of-type(1)': {
          '&:hover .container': {
            transformOrigin: 'center right',
          },
        },
        ...incomingSx,
      }}
      {...rest}
    >
      {children}
    </Stack>
  );
}
